export default __webpack_public_path__ + "static/media/Img0176.cbf6d8d2.jpg";